import { render } from "./game-content-trivia.vue?vue&type=template&id=7c043f56&scoped=true"
import script from "./game-content-trivia.vue?vue&type=script&lang=js"
export * from "./game-content-trivia.vue?vue&type=script&lang=js"

import "./game-content-trivia.vue?vue&type=style&index=0&id=7c043f56&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c043f56"],['__file',"src/components/notepad/parts/game-content-trivia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c043f56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c043f56', __exports__)) {
    api.reload('7c043f56', __exports__)
  }
  
  module.hot.accept("./game-content-trivia.vue?vue&type=template&id=7c043f56&scoped=true", () => {
    api.rerender('7c043f56', render)
  })

}


export default __exports__